export default __webpack_public_path__ + "static/media/border1.b0a2c574.svg";